import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=0e1babdd"
import script from "./PersonDetails.vue?vue&type=script&lang=ts"
export * from "./PersonDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports